<div *ngIf="form" [formGroup]="form">
  <input type="hidden" #main formControlName="main">
</div>
<input
  cdkFocusInitial
  #userTypesHere
  class="w-100"
  [type]="type"
  [ngModel]="bufferedInput"
  [style.text-transform]="textTransform"
  (ngModelChange)="changed($event)"
/>
